import React from 'react'
import { Card, CardBody, Row, Col, FormGroup, Label, Input, } from 'reactstrap'
import getBaseQuery from '../../../helpers/assessment/getBaseQuery'

export default function FilterByBar({ query, navTo }) {

  function getAns(query) {
    let ans = 'all'
    if (query && query.ans) {
      ans = query.ans
    }
    return ans
  }

  const baseQuery = getBaseQuery(query, 'ans')
  const ans = getAns(query)

  return (
    <div className='filter-bar'>
      <b>&nbsp;</b>
      <FormGroup check>
        <Label check className='m2clickable'>
          <Input
            type='radio'
            value='viewAll'
            name='filterByAnswers'
            checked={ans === 'all' || !ans}
            onClick={() => navTo(`${baseQuery}&ans=all`)}
            readOnly
          />
          {' '}View All
                </Label>
      </FormGroup>
      <FormGroup>
        <Label check className='m2clickable'>
          <Input
            type='radio'
            value='correctAnswers'
            name='filterByAnswers'
            checked={ans === 'correct'}
            onClick={() => navTo(`${baseQuery}&ans=correct`)}
            readOnly
          />
          {' '}Correct Answers
                </Label>
      </FormGroup>
      <FormGroup>
        <Label check className='m2clickable'>
          <Input
            type='radio'
            value='incorrectAnswers'
            name='filterByAnswers'
            checked={ans === 'incorrect'}
            onClick={() => navTo(`${baseQuery}&ans=incorrect`)}
            readOnly
          />
          {' '}Incorrect Answers
                </Label>
      </FormGroup>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessOverviewFilter/FilterByBar.js